import * as THREE from 'three';
import type { ScreenPoint } from '../../presentation/party/selection-gesture.js';
import type { UnitPickTarget } from './unit-picking.js';

interface SelectionViewport { left: number; top: number; width: number; height: number }

/** Select body proxies overlapping the rectangle in CSS pixels, without touching animated geometry. */
export function selectUnitsInRectangle(targets: Iterable<UnitPickTarget>, camera: THREE.OrthographicCamera,
  viewport: SelectionViewport, start: ScreenPoint, end: ScreenPoint): string[] {
  if (viewport.width <= 0 || viewport.height <= 0) return [];
  const left = Math.max(-1, (Math.min(start.x, end.x) - viewport.left) / viewport.width * 2 - 1);
  const right = Math.min(1, (Math.max(start.x, end.x) - viewport.left) / viewport.width * 2 - 1);
  const top = Math.min(1, 1 - (Math.min(start.y, end.y) - viewport.top) / viewport.height * 2);
  const bottom = Math.max(-1, 1 - (Math.max(start.y, end.y) - viewport.top) / viewport.height * 2);
  if (left > right || bottom > top) return [];
  camera.updateWorldMatrix(true, false);
  const point = new THREE.Vector3(), projected = new THREE.Box3(), ids: string[] = [];
  for (const { id, group, hitArea } of targets) {
    if (!group.visible) continue;
    if (!hitArea.geometry.boundingBox) hitArea.geometry.computeBoundingBox();
    const bounds = hitArea.geometry.boundingBox!;
    if (bounds.isEmpty()) continue;
    hitArea.updateWorldMatrix(true, false);
    projected.makeEmpty();
    for (const x of [bounds.min.x, bounds.max.x]) for (const y of [bounds.min.y, bounds.max.y]) for (const z of [bounds.min.z, bounds.max.z]) {
      point.set(x, y, z).applyMatrix4(hitArea.matrixWorld).project(camera);
      projected.expandByPoint(point);
    }
    if (projected.max.z >= -1 && projected.min.z <= 1 && projected.max.x >= left && projected.min.x <= right
      && projected.max.y >= bottom && projected.min.y <= top) ids.push(id);
  }
  return ids;
}
